import React, { useState } from 'react';

import { useTheme } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { useSelector } from 'react-redux';
import { getBannerHeight } from 'src/utils/functions';
import { AppBar, Toolbar, Box, Button, Container, useMediaQuery, IconButton } from '@mui/material';
import { APP_BAR_Z_INDEX, COLOR_PRIMARY_DARK, HEADER_HEIGHT, sidebarClosedWidth } from 'src/utils/const';
import MarketSearchBar from './MarketSearchBar';
import logoMobile from 'src/App/assets/logoMobile.jpg';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import Ribbon from './Ribbon/Ribbon';
import { KPI_CARD_COLOR } from 'src/utils/colors';

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    [theme.breakpoints.up(900)]: {
      paddingLeft: sidebarClosedWidth + theme.spacing(1),
      transition: theme.transitions.create('padding', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
}));

const Header = ({
  sidebarOpen,
  setSidebarOpen,
  search,
  logoutThunk,
  setCurrency,
  user,
  currency,
  setLoginModalOpen,
  dashboardState,
  setdashboardState,
  isMobile,
  handleMarketSidebarClick,
  setSubscriptionModalOpen,
  district,
  isUserVerified,
  cachedSearchMarkets,
  handleSidebarListItemClick,
  centerCoord,
  address,
  dashboardLayoutView,
  openDemoBookingForm,
  setDemoFormHeadingFor,
  dummyMarket,
  cachedTop10MarketCountryWise,
  setOverviewDashboardLayoutView,
  handleOnSampleClick,
  setIsTailoredRegionOpen,
  headerExtraContent,
}) => {
  const classes = useStyles();
  const isTopBannerOpen = useSelector((state: any) => state.dashboard.isTopBannerOpen);
  const theme = useTheme();
  const isMobileBreakPointBanner = useMediaQuery(theme.breakpoints.down(630));
  const [isMobileSearchBarOpen, setIsMobileSearchBarOpen] = useState<boolean>(false);

  const isMarketDashboard =
    dashboardState.showInsightsDashboard &&
    (dashboardLayoutView === 'dashboard' ||
      dashboardLayoutView === 'map' ||
      dashboardLayoutView === 'submarkets' ||
      dashboardLayoutView === 'marketIntelligence') &&
    !window.location.pathname.includes('/airbnb-data/landing');

  const AirbticsLogo = () => (
    <Button>
      <img
        src={logoMobile}
        style={{
          width: '7rem',
          objectFit: 'contain',
          height: 38,
          [theme.breakpoints.down(370)]: {
            width: '7rem',
            height: 30,
          },
        }}
      />
    </Button>
  );

  const RibbonWrapper = (
    <Ribbon
      isMobile={isMobile}
      setIsMobileSearchBarOpen={setIsMobileSearchBarOpen}
      logoutThunk={logoutThunk}
      setCurrency={setCurrency}
      user={user}
      currency={currency}
      setLoginModalOpen={setLoginModalOpen}
      dashboardState={dashboardState}
      handleMarketSidebarClick={handleMarketSidebarClick}
      setSubscriptionModalOpen={setSubscriptionModalOpen}
      handleSidebarListItemClick={handleSidebarListItemClick}
      centerCoord={centerCoord}
      address={address}
      openDemoBookingForm={openDemoBookingForm}
      setDemoFormHeadingFor={setDemoFormHeadingFor}
      dummyMarket={dummyMarket}
      isMarketDashboard={isMarketDashboard}
    />
  );

  const SearchbarWrapper = (
    <Box
      id="searchBar"
      sx={{
        maxWidth: '500px',
        width: isMobile ? '100vw' : '40vw',
        alignItems: 'center',
        display: isMarketDashboard ? 'flex' : 'none',
        marginRight: '5px',
      }}
    >
      <MarketSearchBar
        search={search}
        showAlert={() => {}}
        notShowAlert={() => {}}
        setdashboardState={setdashboardState}
        user={user}
        district={district}
        isUserVerified={isUserVerified}
        cachedSearchMarkets={cachedSearchMarkets}
        closeMobileSearch={() => setIsMobileSearchBarOpen(false)}
        source="header"
        isMobileScreen={isMobile}
        cachedTop10MarketCountryWise={cachedTop10MarketCountryWise}
        handleCustomOnClose={() => isMobileSearchBarOpen && setIsMobileSearchBarOpen(false)}
        setOverviewDashboardLayoutView={setOverviewDashboardLayoutView}
        dummyMarket={dummyMarket}
        handleOnSampleClick={handleOnSampleClick}
        setIsTailoredRegionOpen={setIsTailoredRegionOpen}
      />
    </Box>
  );

  const SEOWildcardElem = (
    <Box
      sx={{
        position: 'absolute',
        left: '-999999px',
      }}
    >
      <a href="https://airbtics.com">Airbnb Data</a>
    </Box>
  );

  const DesktopHeader = (
    <Toolbar
      disableGutters
      sx={{
        justifyContent: (isMarketDashboard || headerExtraContent) ? 'space-between' : 'flex-end',
      }}
    >
      {isMarketDashboard ? SearchbarWrapper : headerExtraContent || null}
      {RibbonWrapper}
    </Toolbar>
  );

  const MobileHeader = (
    <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
      <>
        {isMarketDashboard &&
          (isMobileSearchBarOpen ? (
            SearchbarWrapper
          ) : (
            <IconButton
              sx={{
                width: 46,
                height: 46,
                borderRadius: 200,
                border: `4px solid ${COLOR_PRIMARY_DARK}`,
                backgroundColor: COLOR_PRIMARY_DARK,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                '&:hover': {
                  backgroundColor: COLOR_PRIMARY_DARK + 'AA',
                },
              }}
              onClick={() => setIsMobileSearchBarOpen(true)}
            >
              <SearchRoundedIcon
                sx={{
                  width: 30,
                  height: 30,
                  cursor: 'pointer',
                  color: '#fff',
                }}
              />
            </IconButton>
          ))}

        {!isMobileSearchBarOpen && <AirbticsLogo />}

        {RibbonWrapper}
      </>
    </Toolbar>
  );

  return (
    <AppBar
      className={classes.content}
      sx={{
        top: isTopBannerOpen ? getBannerHeight(isMobileBreakPointBanner) : 0,
        height: HEADER_HEIGHT,
        zIndex: APP_BAR_Z_INDEX,
        pt: 1,
        pb: 1,
        position: 'fixed',
        bgcolor: 'white',
      }}
    >
      <Container
        maxWidth="xl"
        sx={isMobile && isMarketDashboard ? { paddingLeft: '5px', paddingRight: '5px' } : {}}
      >
        {isMobile ? MobileHeader : DesktopHeader}
      </Container>
      {SEOWildcardElem}
    </AppBar>
  );
};

export default Header;
